export default "__VITE_ASSET__CNv$CuzN__"